module.exports = __webpack_public_path__ + "img/1.cfe2fd89.png";